import Constants from 'src/core/utils/Constants';

class ValidationService {
	isOpenableUrl(url: unknown): url is string {
		const protocol = this.protocolOf(url);

		return protocol !== null && Constants.allowedExternalUrlSchemes.includes(protocol);
	}

	isWebUrl(url: unknown): url is string {
		const protocol = this.protocolOf(url);

		return protocol !== null && Constants.webUrlSchemes.includes(protocol);
	}

	protocolOf(url: unknown): string | null {
		if (typeof url !== 'string') {
			return null;
		}

		try {
			return new URL(url.trim()).protocol;
		} catch {
			return null;
		}
	}

	isValidEmail(email: unknown): email is string {
		if (typeof email !== 'string') {
			return false;
		}

		const trimmed = email.trim();

		if (trimmed === '' || trimmed.includes('..')) {
			return false;
		}

		return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(trimmed);
	}
}

export default new ValidationService();
